import { money } from "./settlementApi";

const ROWS = [
  ["customer_paid", "Customer has paid (rent + bond + charges paid separately)"],
  ["rental_adjustment", "Rent change"],
  ["charges_added", "Extra charges added"],
  ["bond_used", "Bond used for charges"],
  ["bond_retained", "Bond kept"],
  ["bond_refund_due", "Bond to refund"],
  ["rent_refund_due", "Rent to refund"],
  ["credit_issued", "Mahra Rental Credit to issue"],
  ["bond_used_total_after", "Total bond used (all charges)"],
  ["bond_refunded_total_after", "Total bond refunded"],
  ["bond_remaining_after", "Bond left after this"],
  ["outstanding_after", "Still owed by customer"],
];

const PaidBreakdown = ({ b }) => (
  <div className="px-4 pb-1.5 -mt-0.5 text-[11px] text-[#676664]" data-testid="settle-preview-customer-paid-breakdown">
    rent paid {money(b.rent_paid)} · bond {money(b.bond)} · paid separately {money(b.paid_separately)} · settled from bond {money(b.settled_from_bond)}
  </div>
);

export function PreviewTable({ pv }) {
  return (
    <div className="border border-[#9A7B4F]/25 bg-[#FAF8F0]" data-testid="settle-preview">
      <div className="px-4 py-2 text-[10px] uppercase tracking-[0.14em] text-[#9A7B4F] border-b border-[#9A7B4F]/15">Settlement preview — nothing saved yet</div>
      {pv.corrections?.length > 0 && (
        <ul className="px-4 py-2 space-y-0.5 text-[12px] text-[#282828] border-b border-[#9A7B4F]/15" data-testid="settle-preview-corrections">
          {pv.corrections.map((c, i) => <li key={i} data-testid={`settle-preview-correction-${i}`}>• {c.label}</li>)}
        </ul>
      )}
      <dl className="divide-y divide-[#282828]/5 text-[12px]">
        {ROWS.map(([k, label]) => (
          <div key={k}>
            <div className="flex justify-between px-4 py-1.5">
              <dt className="text-[#676664]">{label}</dt>
              <dd className="font-medium text-[#282828] tabular-nums" data-testid={`settle-preview-${k}`}>
                {k === "rental_adjustment" && pv[k] > 0 ? "+" : ""}{pv[k] === undefined ? "—" : money(pv[k])}
              </dd>
            </div>
            {k === "customer_paid" && pv.customer_paid_breakdown && <PaidBreakdown b={pv.customer_paid_breakdown} />}
          </div>
        ))}
        <div className="flex justify-between px-4 py-2 bg-white">
          <dt className="text-[#282828] font-medium">Final balance</dt>
          <dd className="font-semibold text-[#9A7B4F] tabular-nums" data-testid="settle-preview-final_balance">{money(pv.final_balance)}</dd>
        </div>
      </dl>
    </div>
  );
}
